module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pageTitle":"Absenkpfad","section":{"s12e":"Scope 1-2","s123e":"Scope 1-3","s1e":"Scope 1","s2e":"Scope 2","s3e":"Scope 3","ee":"Endenergie","pe":"Primärenergie (PE)","penr":"PE Fossil","per":"PE Erneuerbar","efficiencyClasses":"Effizienzklassen","heat":"Wärme","electricity":"Elektrizität","costs":"Investitionskosten"}}}')
  delete Component.options._Ctor
}
